import DropDownSearch from '../../../../components/DropDownSearch';
import { useState, useEffect } from 'react';
import HesSpinner from '../../../../components/loadingOverlay/hesSpinner';
import { Button } from 'react-bootstrap';
import { useOutletContext, useParams } from 'react-router';
import { useQuestionSearchContext } from '../../components/castleQuestionsSearch/context';
import { useData } from '../../../assignments/ExamAndAssignmentsContext';
import PublicAssignments from './pages/publicAssignments';
import YourAssignments from './pages/yourAssignments';
import { useActivitySearchContext } from '../../../activitySearch/context';
import ActivityTypes from '../../../../enums/activityTypes';

const ExamsAndAssignments = () => {
  const { activityType } = useParams();
  const [searchType, setSearchType] = useState('stateTests');
  const [, setSelectedIds] = useState([]);
  const [courses, setCourses] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedAssignmentId, setSelectedAssignmentId] = useState(0);

  const { courseData, folderData } = useData();
  const outletContext = useOutletContext();
  const questionSearchContext = useQuestionSearchContext();
  const activitySearchContext = useActivitySearchContext();
  const context = (activityType == ActivityTypes.Assignment ? questionSearchContext : activitySearchContext);

  const handleSelectionChange = (e, filterList, setFilterList) => {
    const { key } = e;
    const selected = (key !== '000') ? filterList.find((v) => v.id == key) : filterList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterList.map((item) => ({
        ...item,
        isChecked: !filterList.filter(item => item?.isChecked !== true).length < 1,
      }));
    } else {
      tempValue = filterList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setFilterList(tempValue);
  };

  const SearchQuestions = () => {
    var searchRequest = {
      pageNumber: 1,
      pageSize: 25
    };

    switch (searchType) {
    case 'stateTests':
      searchRequest.courseIds = context.examsTabSelectedCourses.filter(c => c.isChecked).map(c => c.id);
      searchRequest.levels = context.examsTabSelectedGrades.filter(g => g.isChecked).map(g => g.gradeId).flat(1);
      searchRequest.states = context.examsTabSelectedStates.filter(s => s.isChecked).map(s => s.id);
      searchRequest.years = context.examsTabSelectedExamYears.filter(y => y.isChecked).map(y => y.id);
      outletContext.initializeExamSearch(searchRequest);
      break;
    case 'yourAssignment':
      searchRequest.assignmentId = selectedAssignmentId;
      outletContext.initializeTeacherAssignmentSearch(searchRequest);
      break;
    case 'publicAssignment':
      searchRequest.assignmentId = selectedAssignmentId;
      outletContext.initializePublicAssignmentSearch(searchRequest);
      break;
    }
  };

  const SearchVocabularies = () => {
    var searchRequest = {
      pageNumber: 1,
      pageSize: 25
    };

    switch (searchType) {
    case 'stateTests':
      searchRequest.courseIds = context.examsTabSelectedCourses.filter(c => c.isChecked).map(c => c.id);
      searchRequest.levels = context.examsTabSelectedGrades.filter(g => g.isChecked).map(g => g.gradeId).flat(1);
      searchRequest.states = context.examsTabSelectedStates.filter(s => s.isChecked).map(s => s.id);
      searchRequest.years = context.examsTabSelectedExamYears.filter(y => y.isChecked).map(y => y.id);
      context.setApiIdentifier('stateTestSearch');
      context.setApiParams(searchRequest);
      break;
    case 'yourAssignment':
      searchRequest.assignmentId = selectedAssignmentId;
      context.setApiParams(searchRequest);
      context.setApiIdentifier('yourFlashcardSearch');
      break;
    case 'publicAssignment':
      searchRequest.assignmentId = selectedAssignmentId;
      context.setApiParams(searchRequest);
      context.setApiIdentifier('publicFlashcardSearch');
      break;
    }
  };
  useEffect(() => {
    getAllCoursesAsync();
  }, [courseData]);

  useEffect(() => {
    getAllFoldersAsync();
  }, [folderData]);

  const getAllCoursesAsync = async () => {
    try {
      const obj = {
        id: -1,
        name: 'All Courses'
      };
      const courseArray = [obj, ...courseData];
      courseArray !== null && courseArray !== undefined
        ? setCourses(courseArray)
        : setCourses([obj]);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllFoldersAsync = async () => {
    try {
      const folderArray = [];
      folderData.filter(item => item.folderID !== -88).map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'Any Folder'
      };
      let FolderArrayResponse = [objData, ...folderArray];
      if(activityType == ActivityTypes.FlashCard){
        FolderArrayResponse = FolderArrayResponse.map((item) => ({
          ...item,
          name: item.name.replace(/Shared Assignments?/i, 'Shared Flashcards')
        }));
      }
      FolderArrayResponse !== null && FolderArrayResponse !== undefined
        ? setFolders(FolderArrayResponse)
        : setFolders([objData]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedAssignmentId != 0)
      if(activityType == ActivityTypes.Assignment){
        SearchQuestions();
      }
      else{
        SearchVocabularies();
      }
  }, [selectedAssignmentId]);

  return (
    <>
      <div className='d-flex flex-column castleQuestionsSearchBox'>
        {(outletContext.courseFilters?.isLoading || context.courseLoading) && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
          <HesSpinner width='2%' />
          <span className='fs-2 ms-2'>Getting your courses...</span>
        </div>}

        {(outletContext.courseFilters?.isSuccess  || context.primaryCourseFilters.length > 0) && <div className='castleQuestionsSearchTypeList mb-3'>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'stateTests' ? 'active' : ''}`} onClick={() => { setSearchType('stateTests'); context.setActivityName(''); context.setShowResults(false); setSelectedAssignmentId(0); }}>State Tests</span>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'yourAssignment' ? 'active' : ''}`} onClick={() => { setSearchType('yourAssignment'); context.setActivityName(''); context.setShowResults(false); setSelectedAssignmentId(0); }}>{`Your  ${activityType == ActivityTypes.Assignment ? 'Assignments' : 'Flashcards'}`}</span>
          <span className={`px-3 py-2 rounded-2 ${searchType == 'publicAssignment' ? 'active' : ''}`} onClick={() => { setSearchType('publicAssignment'); context.setActivityName(''); context.setShowResults(false); setSelectedAssignmentId(0); }}>{`Public  ${activityType == ActivityTypes.Assignment ? 'Assignments' : 'Flashcards'}`}</span>
        </div>}

        {searchType === 'stateTests' &&
          <>
            {(outletContext.courseFilters?.isSuccess  || !context.courseLoading) && <div className='d-flex flex-row gap-3 mb-3 align-items-center'>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Grade</span>
                <DropDownSearch
                  value={context.examsTabSelectedGrades}
                  setValue={context.setExamsTabSelectedGrades}
                  dropdownId='gradesFilter'
                  placeholder='Grades'
                  handleChange={(e) => handleSelectionChange(e, context.examsTabSelectedGrades, context.setExamsTabSelectedGrades)}
                  selectedId={context.examsTabSelectedGrades.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Grades'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Content Area</span>
                <DropDownSearch
                  value={context.examsTabSelectedCourses}
                  setValue={context.setExamsTabSelectedCourses}
                  dropdownId='contentAreaFilter'
                  placeholder='Content Area'
                  handleChange={(e) => handleSelectionChange(e, context.examsTabSelectedCourses, context.setExamsTabSelectedCourses)}
                  selectedId={context.examsTabSelectedCourses.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Content Areas'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select State</span>
                <DropDownSearch
                  value={context.examsTabSelectedStates}
                  setValue={context.setExamsTabSelectedStates}
                  dropdownId='stateFilter'
                  placeholder='State'
                  handleChange={(e) => handleSelectionChange(e, context.examsTabSelectedStates, context.setExamsTabSelectedStates)}
                  selectedId={context.examsTabSelectedStates.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All States'
                />
              </div>
              <div className='d-flex flex-column w-100'>
                <span className='fw-500 pb-1'>Select Exam Year</span>
                <DropDownSearch
                  value={context.examsTabSelectedExamYears}
                  setValue={context.setExamsTabSelectedExamYears}
                  dropdownId='examYearFilter'
                  placeholder='Exam Year'
                  handleChange={(e) => handleSelectionChange(e, context.examsTabSelectedExamYears, context.setExamsTabSelectedExamYears)}
                  selectedId={context.examsTabSelectedExamYears.filter(m => m.isChecked).map(m => m.id)}
                  setSelectedId={setSelectedIds}
                  description={true}
                  selectAllText='All Exam Years'
                />
              </div>
              <Button variant='castleWhite w-30' className='mt-4' onClick={() => activityType == ActivityTypes.Assignment ? SearchQuestions() : SearchVocabularies()}
                disabled={context.isSearching ||
                  context.examsTabSelectedGrades.filter(g => g.isChecked)?.length == 0 ||
                  context.examsTabSelectedCourses.filter(c => c.isChecked)?.length == 0 ||
                  context.examsTabSelectedExamYears.filter(e => e.isChecked)?.length == 0 ||
                  context.examsTabSelectedStates.filter(s => s.isChecked)?.length == 0}>
                Search
              </Button>
            </div>}
          </>
        }
        {searchType === 'yourAssignment' &&
          <YourAssignments
            courses={courses}
            folders={folders}
            setSelectedAssignmentId={setSelectedAssignmentId}
            setShowResults={context.setShowResults}
            activityType={activityType}
            setActivityName={context.setActivityName}
          />
        }
        {searchType === 'publicAssignment' &&
          <PublicAssignments
            courses={courses}
            setSelectedAssignmentId={setSelectedAssignmentId}
            setShowResults={context.setShowResults}
            activityType={activityType}
            setActivityName={context.setActivityName}
          />
        }
      </div >
    </>
  );
};

export default ExamsAndAssignments;
